import { assignInlineVars } from "@vanilla-extract/dynamic";
import clsx from "clsx";
import type React from "react";
import { type CSSProperties, forwardRef } from "react";
import { IconTakeatFilled } from "../icons";
import {
  accentVar,
  loadingPageContainer,
  loadingPageOrientationVariants,
} from "./styles.css";

interface LoadingPageProps extends React.HTMLAttributes<HTMLDivElement> {
  customColor?: string;
  text?: string;
  reversed?: boolean;
}

export const LoadingPage = forwardRef(function LoadingPage(
  {
    customColor,
    text = "Carregando...",
    reversed,
    className,
    ...props
  }: LoadingPageProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const orientationClass =
    loadingPageOrientationVariants[reversed ? "reversed" : "standard"];
  const customStyles = customColor
    ? (assignInlineVars({ [accentVar]: customColor }) as CSSProperties)
    : undefined;

  return (
    <div
      ref={ref}
      className={clsx(loadingPageContainer, orientationClass, className)}
      style={customStyles}
      {...props}
    >
      <IconTakeatFilled fontSize={125} />
      <span>{text}</span>
    </div>
  );
});

LoadingPage.displayName = "LoadingPage";
